import React from 'react';

const Categories = () => (
  <div>
    <input type="submit" className="submit status" value="Check Status" />
  </div>
);

export default Categories;
